module.exports = __webpack_public_path__ + "img/lawjudge1.2d65cd55.png";